import { render, staticRenderFns } from "./TabsWrapper.vue?vue&type=template&id=12c4445b&"
import script from "./TabsWrapper.vue?vue&type=script&lang=js&"
export * from "./TabsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports